import { Component } from "react";
import "../Links/Links.min.css";

export default class LoadingPlaceholderCardComponent extends Component {

    props: any;

    render() {

        return (
            
            <div className={`item mst-carousel-item d-flex overflow-hidden mx-3 mx-md-4 api-list-item-card api-placeholder-card`} >

                <div className="mst-card mst-box-item d-flex flex-column" >

                 
                    <div className="mb-2 mb-md-4">
                        <div className="mb-4">
                            <div className="img-placeholder placeholder"></div>
                        </div>
                            


                        <div className={"mst-card-content content-txt overflow-hidden px-4 px-lg-0 "}>

                            <div className="row mb-3">
                                <div className="loading-placeholder-title-line my-1 placeholder col-12"></div>
                                <div className="loading-placeholder-title-line my-1 placeholder col-7"></div>
                            </div>

                            <div className=" mx-auto mx-md-0 mb-3 hr placeholder-hr"></div>

                            <div className="mst-link-carousel-content" >

                                <div className="row">
                                    <div className="loading-placeholder-desc-line placeholder my-1 col-12"></div>

                                    <div className="loading-placeholder-desc-line placeholder my-1 col-12"></div>
                                    <div className="loading-placeholder-desc-line placeholder my-1 col-4"></div>
                                </div>

                                <ul style={{ listStyleType: 'none' }} className="mst-link-carousel-api-content-rows mx-2 px-1">
                                    {
                                        [1, 2, 3, 4].map((row, idx) => <li className="row" key={idx}>
                                            <div className="api-content-row-icon-wrapper">
                                                <i aria-hidden="true" className={`fa fa-solid fa-spinner icon-color fa-pulse mx-1`}></i>
                                            </div>
                                            <div className="row-title placeholder col-4 px-1"></div>
                                            <span className="row-content mx-1 placeholder col-4"></span>
                                        </li>)
                                    }

                                </ul>

                            </div>

                                                              
                        </div>
                    </div>

                    <div className="align-bottom px-4 px-lg-0 pb-3" >

                        <div className="placeholder-btn placeholder mst-btn mst-btn-round px-auto" ></div>

                    </div>

                </div>
              
            </div>

        );
    }
}
